import { ContentTopBar } from 'components'
import { UploadDetailsTable } from 'features/transaction_list/component/upload-deatils-list-tabel/upload-details-list-UploadDetails-table';
import { useGetUploadDetails } from 'features/transaction_list/use-cases/get-upload-details';
import { usePaginationParams } from 'hooks';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';

const UploadListDetails = () => {
    const location = useLocation();
    const { id } = useParams();
    const params1 = new URLSearchParams(location.search);

    const eventId = params1.get("eventId");
    const { params, updateParams } =
        usePaginationParams<any>({
            id: id,
            eventId: eventId,
            page: 1,
            size: 10,
        });
    const [searchParams] = useSearchParams();
    const origin = searchParams.get("origin");
    const originType =
        origin === "BulkUpload" ? "bulkupload" : "groupregistration";

    const { data, isFetching, refetch } = useGetUploadDetails(
        params,          
        originType,      
        { retry: false } 
    );

    const updatedTitle: string | undefined = location.pathname.includes("/group-registration-List")
        ? "Group Registration"
        : "Bulk Upload"


    return (
        <>

            <ContentTopBar
                title={`${updatedTitle} Participant List`}
            />


            <UploadDetailsTable
                data={data}
                isLoading={isFetching}
                tableParams={params}
                refetch={refetch}
                updateParams={updateParams}
                id={id}

            />
        </>
    )
}

export default UploadListDetails
